// src/hooks/useFetchCities.js
import { useState, useEffect, useCallback } from "react";
import { api } from "../api";

export default function useFetchCities() {
  const [cities, setCities]   = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError]     = useState(null);

  const loadCities = useCallback(async () => {
    setLoading(true);
    setError(null);

    try {
      const data = await api.getCities();
      setCities(data);
      // console.log(data);
    } catch (err) {
      console.error("Error loading cities:", err);
      setError(err);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    loadCities();
  }, [loadCities]);

    
  return { cities, loading, error, refetch: loadCities };
}
